export const BEIJING_TIME_ZONE = 'Asia/Shanghai'

const partsOf = value => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return new Intl.DateTimeFormat('en-US', {
    timeZone: BEIJING_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date).reduce((parts, part) => {
    if (part.type !== 'literal') parts[part.type] = part.value
    return parts
  }, {})
}

export function beijingDateParts(value = Date.now()) {
  return partsOf(value)
}

export function beijingDateString(value = Date.now()) {
  const parts = partsOf(value)
  return parts ? `${parts.year}-${parts.month}-${parts.day}` : ''
}

export function formatBeijingTime(value, options = {}) {
  if (!value || Number.isNaN(new Date(value).getTime())) return ''
  return new Intl.DateTimeFormat('zh-CN', {
    timeZone: BEIJING_TIME_ZONE,
    ...options,
  }).format(new Date(value))
}
